import * as React from "react";
import { useLayoutEffect, useRef, useState } from "react";
import { Button } from "semantic-ui-react";

interface PlaceholderButtonProps {
  placeholder: string;
  displayName: string;
}

const PlaceholderButton: React.FC<PlaceholderButtonProps> = ({ placeholder, displayName }) => {
  const buttonRef = useRef(null);
  const [frozenWidth, setFrozenWidth] = useState<string>();

  const [displayCopied, setDisplayCopied] = useState(false);

  const copyPlaceholder = () => {
    const focusedElement = document.activeElement;
    if (
      ["INPUT", "TEXTAREA"].includes(focusedElement?.tagName || "") &&
      (focusedElement as any).name.match(/^widgets\.\d+\.owner.[a-zA-Z0-9]+$/)
    ) {
      document.execCommand("insertText", false, `{{${placeholder}}}`);
    } else {
      setDisplayCopied(true);
      navigator.clipboard.writeText(`{{${placeholder}}}`);
      setTimeout(() => setDisplayCopied(false), 1000);
    }
  };
  useLayoutEffect(() => {
    if (!buttonRef.current) return;

    // When a placeholder is copied and we update the text/icon within the button, the width of the button changes.
    // This keeps it at the same width so the UI doesn't jump around when copying.
    const computedWidth = window.getComputedStyle(buttonRef.current).width;
    setFrozenWidth(computedWidth);
  }, []);

  return (
    <div ref={buttonRef}>
      <Button
        className={`placeholderButton ${displayCopied ? "copied" : ""}`}
        style={{ width: frozenWidth }}
        onMouseDown={(e: any) => e.preventDefault()}
        content={displayCopied ? "Copied!" : displayName}
        onClick={copyPlaceholder}
      />
    </div>
  );
};
export default PlaceholderButton;
